import { render, staticRenderFns } from "./cowslistings.vue?vue&type=template&id=37a351a2&scoped=true&"
import script from "./cowslistings.vue?vue&type=script&lang=js&"
export * from "./cowslistings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a351a2",
  null
  
)

export default component.exports